export interface IAxSpinnerOptions {
    className: string;
    id: string;
    containerId: string;
    width: number;
    height: number;
};

export default class AxSpinner {
    private isBuilt: boolean = false;
    private spinner: HTMLDivElement;
    private options: IAxSpinnerOptions = {
        className: '',
        id: '',
        containerId: 'ax-container-spinner',
        width: 50,
        height: 50,
    };

    public constructor(optionsParam: IAxSpinnerOptions) {
        // Combine user provided options if present
        if (optionsParam && typeof optionsParam === 'object') {
            Object.assign(this.options, optionsParam);
        }

        if (!this.isBuilt) {
            AxSpinner.buildSpinner(this);
        }
    }

    // Build spinner private function
    private static buildSpinner(spinnerInstance: AxSpinner) {
        const options = spinnerInstance.options;

        // Create Spinner container
        const spinner = document.createElement('div');
        let axSpinnerContainer = document.getElementById(options.containerId) as HTMLDivElement;
        if (axSpinnerContainer === null || axSpinnerContainer === undefined)
        {
            axSpinnerContainer = document.createElement('div');
        }
        spinnerInstance.spinner = spinner;

        // Set spinner and variant classes
        spinner.classList.add('ax-spinner');
        if (options.className) {
            spinner.classList.add(options.className);
        }

        // SPINNER SVG -----------------------------------------------------
        spinner.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${options.width}" height="${options.height}" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="value" data-v-f6cfd3a8="" data-v-5ac71a96="" style="background: none; display: block; shape-rendering: auto; margin: 0px auto;"><circle cx="84" cy="50" r="10" fill="#00205a"><animate attributeName="r" repeatCount="indefinite" dur="0.5319148936170213s" calcMode="spline" keyTimes="0;1" values="15;0" keySplines="0 0.5 0.5 1" begin="0s"></animate><animate attributeName="fill" repeatCount="indefinite" dur="2.127659574468085s" calcMode="discrete" keyTimes="0;0.25;0.5;0.75;1" values="#00205a;#007a91;#796597;#0dae8e;#00205a" begin="0s"></animate></circle><circle cx="16" cy="50" r="10" fill="#00205a"><animate attributeName="r" repeatCount="indefinite" dur="2.127659574468085s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;15;15;15" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s"></animate><animate attributeName="cx" repeatCount="indefinite" dur="2.127659574468085s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s"></animate></circle><circle cx="50" cy="50" r="10" fill="#0dae8e"><animate attributeName="r" repeatCount="indefinite" dur="2.127659574468085s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;15;15;15" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.5319148936170213s"></animate><animate attributeName="cx" repeatCount="indefinite" dur="2.127659574468085s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.5319148936170213s"></animate></circle><circle cx="84" cy="50" r="10" fill="#796597"><animate attributeName="r" repeatCount="indefinite" dur="2.127659574468085s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;15;15;15" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.0638297872340425s"></animate><animate attributeName="cx" repeatCount="indefinite" dur="2.127659574468085s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.0638297872340425s"></animate></circle><circle cx="16" cy="50" r="10" fill="#007a91"><animate attributeName="r" repeatCount="indefinite" dur="2.127659574468085s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;15;15;15" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.5957446808510638s"></animate><animate attributeName="cx" repeatCount="indefinite" dur="2.127659574468085s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.5957446808510638s"></animate></circle><!-- [ldio] generated by https://loading.io/ --></svg>`;

        // Append spinner to the root
        axSpinnerContainer.appendChild(spinner);
        spinnerInstance.isBuilt = true;
    }

    // Public methods
    public show() {
        if (!this.isBuilt) {
            AxSpinner.buildSpinner(this);
        }
        this.spinner.classList.add(`ax-spinner--appear`);
    }

    public hide() {
        if (this.spinner) {
            this.spinner.classList.remove(`ax-spinner--appear`);
        }
    }

    public destroy() {
        this.spinner.remove();
        this.isBuilt = false;
    }
}